export const setIdCoin = id => {
    return { type: 'SET_ID_COIN', payload: parseInt(id) }
}